import { WidgetType } from '@lastbrand/storefront-proto-registry/api/v1/enums'
import { ProductListWidgetData } from '@lastbrand/storefront-proto-registry/api/v1/widget'

import { PLBaseErrorBoundary } from '@src/components/pl-base-error-boundary'
import { PLTypedWidgetInterface, PLTypedWidgetProps } from '@src/components/pl-base-widget'
import { shouldUseDesignSystem } from '@src/utils/should-use-design-system'

import { ProductGridDSWidget } from './product-grid-ds-widget'
import { ProductGridWidgetLegacy } from './product-grid-legacy'

const ProductGridWidgetComponent = (props: PLTypedWidgetProps<ProductListWidgetData>) => {
  if (shouldUseDesignSystem()) {
    return <ProductGridDSWidget {...props} />
  }
  return <ProductGridWidgetLegacy {...props} />
}

export const ProductGridWidget: PLTypedWidgetInterface<ProductListWidgetData, WidgetType.PRODUCT_LIST> = {
  id: WidgetType.PRODUCT_LIST,
  render: ProductGridWidgetComponent,
  errorBoundary: PLBaseErrorBoundary,
}
